import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// Remove LanguageDetector import if you don't want it overriding your settings
// import LanguageDetector from "i18next-browser-languagedetector"; 

import en from "./translations/en.json";
import hi from "./translations/hi.json";
import mr from "./translations/mr.json";

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  mr: { translation: mr }
};

i18n
  // .use(LanguageDetector) // Comment this out to stop it from picking browser language
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",             // <--- Add this: Explicitly sets English as the starting language
    fallbackLng: "en",      // Use English if a translation is missing
    interpolation: {
      escapeValue: false
    },
    // If you keep LanguageDetector, add this to prevent it from saving the last session:
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: [] // This prevents it from remembering the previous language
    }
  });

export default i18n;